const PdfIcon = (props) => (
  <svg
    width="26"
    height="33"
    viewBox="0 0 26 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7378 0V6.48848C18.7378 6.93836 19.0968 7.29954 19.544 7.29954H25.9936L18.7378 0Z"
      fill="#FFFFFF"
    />
    <path
      d="M8.58469 13.3887H8.1123V15.7015H8.64767C9.03188 15.7015 9.32791 15.6064 9.53575 15.41C9.7436 15.2136 9.84438 14.9284 9.84438 14.5546C9.84438 14.1807 9.7436 13.8956 9.53575 13.6928C9.3342 13.4901 9.01298 13.3887 8.58469 13.3887Z"
      fill="#FFFFFF"
    />
    <path
      d="M5.49857 13.5154C5.3663 13.4203 5.16475 13.376 4.88762 13.376H4.40894V14.6559H4.9758C5.25923 14.6559 5.44818 14.5989 5.54895 14.4848C5.64973 14.3708 5.70012 14.206 5.70012 13.9843C5.69382 13.7625 5.62454 13.6104 5.49857 13.5154Z"
      fill="#FFFFFF"
    />
    <path
      d="M16.1681 10.8984H1.46754C0.655039 10.8984 0 11.5638 0 12.3748V16.7216C0 17.539 0.655039 18.198 1.46754 18.198H16.1618C16.9743 18.198 17.6294 17.539 17.6294 16.7216V12.3748C17.6357 11.5638 16.9806 10.8984 16.1681 10.8984ZM6.14729 15.0615C5.87645 15.2769 5.46076 15.3846 4.90019 15.3846H4.39632V16.4428H3.55862V12.6409H4.8939C5.47335 12.6409 5.89535 12.755 6.15988 12.9831C6.42442 13.2112 6.55669 13.5597 6.55669 14.0286C6.55669 14.5038 6.42442 14.846 6.14729 15.0615ZM10.172 15.9359C9.81928 16.278 9.28391 16.4555 8.56589 16.4555H7.27471V12.6536H8.60998C9.28391 12.6536 9.80039 12.8184 10.1594 13.1542C10.5184 13.4837 10.7011 13.9462 10.7011 14.5355C10.7011 15.1248 10.5247 15.5874 10.172 15.9359ZM14.077 13.395H12.3261V14.2187H13.9889V14.9664H12.3261V16.4555H11.4821V12.6536H14.077V13.395Z"
      fill="#FFFFFF"
    />
    <path
      d="M19.7204 27.6902H17.6356V22.1395C17.6356 21.9558 17.4844 21.8037 17.3018 21.8037H13.0755C12.8928 21.8037 12.7417 21.9558 12.7417 22.1395V27.6902H10.6569C10.3609 27.6902 10.2097 28.0514 10.4176 28.2605L14.9524 32.8988C15.0847 33.0318 15.2988 33.0318 15.4311 32.8988L19.966 28.2605C20.1675 28.0451 20.0164 27.6902 19.7204 27.6902Z"
      fill="#FFFFFF"
    />
    <path
      d="M18.7379 8.41475C18.127 8.41475 17.6357 7.92051 17.6357 7.30588V0H5.87647C5.06397 0 4.40894 0.658986 4.40894 1.47638V9.78975H16.1681C17.5853 9.78975 18.7379 10.9493 18.7379 12.375V16.7218C18.7379 18.1475 17.5853 19.307 16.1681 19.307H4.40894V25.0922C4.40894 25.9096 5.06397 26.5685 5.87647 26.5685H11.6333V22.1267C11.6333 21.3283 12.2757 20.682 13.0693 20.682H17.2956C18.0892 20.682 18.7316 21.3283 18.7316 22.1267V26.5685H19.8779H24.5262C25.3387 26.5685 25.9937 25.9096 25.9937 25.0922V8.41475H18.7379Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default PdfIcon;
